/**
 * Missions Collapse State Storage
 * 
 * Utility functions for localStorage persistence of AVAILABLE MISSIONS
 * and ACTIVE MISSIONS collapsed states per campaign.
 */

// LocalStorage keys
const AVAILABLE_MISSIONS_COLLAPSED_KEY = 'hud-available-missions-collapsed';
const ACTIVE_MISSIONS_COLLAPSED_KEY = 'hud-active-missions-collapsed';
const MILESTONES_COLLAPSED_KEY = 'hud-milestones-collapsed';

/**
 * Get stored collapsed state for Available Missions from localStorage
 */
export const getStoredAvailableCollapsed = (campaignId) => {
  if (!campaignId) return false;
  try {
    const stored = localStorage.getItem(`${AVAILABLE_MISSIONS_COLLAPSED_KEY}_${campaignId}`);
    return stored !== null ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};

/**
 * Save collapsed state for Available Missions to localStorage
 */
export const saveAvailableCollapsed = (campaignId, isCollapsed) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${AVAILABLE_MISSIONS_COLLAPSED_KEY}_${campaignId}`, JSON.stringify(isCollapsed));
  } catch (e) {
    console.warn('Failed to save Available Missions collapsed state:', e);
  }
};

/**
 * Get stored collapsed state for Active Missions from localStorage
 */
export const getStoredActiveCollapsed = (campaignId) => {
  if (!campaignId) return false;
  try {
    const stored = localStorage.getItem(`${ACTIVE_MISSIONS_COLLAPSED_KEY}_${campaignId}`);
    return stored !== null ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};

/**
 * Save collapsed state for Active Missions to localStorage
 */
export const saveActiveCollapsed = (campaignId, isCollapsed) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${ACTIVE_MISSIONS_COLLAPSED_KEY}_${campaignId}`, JSON.stringify(isCollapsed));
  } catch (e) {
    console.warn('Failed to save Active Missions collapsed state:', e);
  }
};

/**
 * Get stored collapsed state for Milestones from localStorage
 */
export const getStoredMilestonesCollapsed = (campaignId) => {
  if (!campaignId) return false;
  try {
    const stored = localStorage.getItem(`${MILESTONES_COLLAPSED_KEY}_${campaignId}`);
    return stored !== null ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};

/**
 * Save collapsed state for Milestones to localStorage
 */
export const saveMilestonesCollapsed = (campaignId, isCollapsed) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${MILESTONES_COLLAPSED_KEY}_${campaignId}`, JSON.stringify(isCollapsed));
  } catch (e) {
    console.warn('Failed to save Milestones collapsed state:', e);
  }
};
